import AnalyticsScreen from "../components/AnalyticsScreen";

const AnalyticsPage = () => {
  return <AnalyticsScreen />;
};

export default AnalyticsPage;
